import { Integration, WorkatoConnectionProvider } from "@intentsify/types";
import { isDefined } from "@intentsify/utils";

const allPossibleProviderOptions: Integration[] = Object.values(
  WorkatoConnectionProvider
)
  .map((provider) => ({ provider, id: 0, connectionId: 0, createdAt: "" }))
  .filter(
    ({ provider }) =>
      provider !== WorkatoConnectionProvider.PROVIDER_UNSPECIFIED
  );

export type IntegrationWithLogo = Integration & {
  logoUrl: string;
};

export const getIntegrationWithLogo = (
  currentCompanyIntegrations: Integration[]
): IntegrationWithLogo[] => {
  return allPossibleProviderOptions
    .map((possibleIntegration) => {
      const existingIntegration = currentCompanyIntegrations.find(
        ({ provider: existingProviderIntegration }) =>
          existingProviderIntegration === possibleIntegration.provider
      );

      if (existingIntegration) {
        return {
          ...existingIntegration,
          logoUrl: `https://intentsify-email-assets.s3.us-west-1.amazonaws.com/${existingIntegration.provider}.svg`,
        };
      }

      return {
        ...possibleIntegration,
        logoUrl: `https://intentsify-email-assets.s3.us-west-1.amazonaws.com/${possibleIntegration.provider}.svg`,
      };
    })
    .filter(isDefined);
};
